// ─────────────────────────────────────────────────────────────────────────────
// src/firebase.js
// Replace firebaseConfig with values from your Firebase project.
// Firebase Console → Project Settings → Your Apps → Web app → Config snippet
// ─────────────────────────────────────────────────────────────────────────────
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import {
  getDatabase,
  ref,
  set,
  onValue,
  off,
} from "firebase/database";

// ── Firebase config — values come from environment variables ─────────────────
// For local dev: create a .env file in the project root (see SETUP_GUIDE.md)
// For production: add these as GitHub Secrets (see SETUP_GUIDE.md)
const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL:       process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};
// ─────────────────────────────────────────────────────────────────────────────

const app  = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getDatabase(app);

// ── Auth ──────────────────────────────────────────────────────────────────────
export const loginUser    = (email, pw) => signInWithEmailAndPassword(auth, email, pw);
export const registerUser = (email, pw) => createUserWithEmailAndPassword(auth, email, pw);
export const logoutUser   = ()          => signOut(auth);
export const onAuthChange = (cb)        => onAuthStateChanged(auth, cb);

// ── Realtime Database ─────────────────────────────────────────────────────────
// Data layout:  /users/{uid}/habits   /users/{uid}/categories   /users/{uid}/completions
const uRef = (uid, path) => ref(db, `users/${uid}/${path}`);

export const writeData  = (uid, path, data) => set(uRef(uid, path), data);
export const subscribe  = (uid, path, cb) => {
  const r = uRef(uid, path);
  onValue(r, snap => cb(snap.val()));
  return () => off(r);
};
